const CONVERSION_PARTNER_ID = "20004350";
const CONVERSION_ENDPOINT = "https://www.google.com/maps/conversion/collect";

function parseAndStoreToken() {
  let rwgToken = new URLSearchParams(location.search).get("rwg_token");
  if (rwgToken) {
    localStorage.setItem("_rwgToken", rwgToken);
    localStorage.setItem(
      "_rwgTokenExpiry",
      Date.now() + 30 * 24 * 60 * 60 * 1000
    );
  }
}

function getStoredToken() {
  let expiry = localStorage.getItem("_rwgTokenExpiry");
  if (!expiry || Date.now() > Number(expiry)) {
    localStorage.removeItem("_rwgToken");
    localStorage.removeItem("_rwgTokenExpiry");
    return undefined;
  }
  return localStorage.getItem("_rwgToken") || undefined;
}

function sendConversionEvent({ merchantChanged = "2" } = {}) {
  let storedRwgToken = getStoredToken();
  if (!storedRwgToken) return;

  fetch(CONVERSION_ENDPOINT, {
    method: "POST",
    body: JSON.stringify({
      conversion_partner_id: CONVERSION_PARTNER_ID,
      rwg_token: decodeURIComponent(storedRwgToken),
      merchant_changed: merchantChanged,
    }),
  });
}

export default { parseAndStoreToken, sendConversionEvent };
